// extracted by mini-css-extract-plugin
module.exports = {"text_icon":"CrowdersTexticon--text_icon--149gv","icon_heading":"CrowdersTexticon--icon_heading--1nEYg"};